import styled from 'styled-components';
import {
  Badge,
  Box,
  Button,
  Text,
  Token,
} from '@usealloy/component-library';
import ReactMarkdown from 'react-markdown';

export const NotificationMenuButton = styled(Button)<{ inNotificationView: boolean }>`
  &&&& {
    align-items: center;
    ${({ inNotificationView }) => (inNotificationView ? 'background-color: var(--cl-background-tertiary-hovered);' : '')}
    border: none;
    border-radius: var(--cl-radius-circle);
    display: flex;
    justify-content: flex-start;
    max-height: var(--cl-space-10);
    max-width: var(--cl-space-10);
    min-height: var(--cl-space-10);
    min-width: var(--cl-space-10);
    padding: var(--cl-space-2);
  }
`;

export const NotificationCountBadge = styled(Badge)`
  &&&& {
    align-items: center;
    justify-content: center;
    border-radius: var(--cl-radius-circle);
    font-size: var(--cl-font-size-1);
    max-height: var(--cl-space-5);
    max-width: var(--cl-space-5);
    min-height: var(--cl-space-5);
    min-width: var(--cl-space-5);
    margin-left: -16px;
    margin-top: -40px;
  }
`;

export const NotificationDropdownItem = styled(Box)`
  border-radius: var(--cl-radius-3);
  padding: var(--cl-space-2);
  &:hover {
    background-color: var(--cl-background-disabled);
    cursor: pointer;
  }
`;

export const NotificationTimestamp = styled(Text)`
  &&&& {
    color: var(--cl-text-muted);
  }
`;

export const NotificationContent = styled(ReactMarkdown)<{ truncateContent: boolean }>`
  &&&& {
    font-size: var(--cl-font-size-2);
    line-height: var(--cl-line-height-4);
    max-width: ${({ truncateContent }) => (truncateContent ? '260px' : '100%')};
    width: ${({ truncateContent }) => (truncateContent ? '260px' : '100%')};
    >p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: ${({ truncateContent }) => (truncateContent ? 'nowrap' : 'wrap')};
      >a {
        color: var(--cl-juicyBlue-600);
        margin: 0;
        text-transform: none;
      }
    }
  }
`;

export const UnreadIndicator = styled(Badge)`
  &&&& {
    background-color: var(--cl-juicyBlue-400);
    border-radius: 100%;
    max-height: var(--cl-space-3);
    min-height: var(--cl-space-3);
    max-width: var(--cl-space-3);
    min-width: var(--cl-space-3);
    padding: 0;
  }
`;

export const NotificationIconWrapper = styled(Box)`
  &&&& {
    max-height: var(--cl-space-5);
    min-height: var(--cl-space-5);
    max-width: var(--cl-space-5);
    min-width: var(--cl-space-5);
  }
`;

export const ToggleReadUnreadText = styled(Text)`
  &&&& {
    color: var(--cl-juicyBlue-600);
    white-space: nowrap;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const NotificationMetaWrapper = styled(Box)`
  max-width: 110px;
  width: 110px;
`;

export const StyledTitle = styled(Text)`
  white-space: normal;
`;

export const StyledNotificationToken = styled(Token)`
  &&&& {
    padding: var(--cl-space-1) var(--cl-space-2);
  }
`;

export const DropdownHeaderWrapper = styled(Box)`
  background-color: var(--cl-background-default);
  padding-top: var(--cl-space-4);
  padding-bottom: var(--cl-space-2);
  position: sticky;
  top: 0;
`;

export const dropdownMenuStyles = {
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.12)',
  maxWidth: '384px',
  minWidth: '384px',
  maxHeight: '448px',
  overflow: 'auto',
  padding: '0 var(--cl-space-5) var(--cl-space-4) var(--cl-space-5)',
};
